<template>
	<div class="module category-tile position-relative">
		<BaseLink :link="{ router: 'help-center-category', params: { categoryId: category.id } }">
			<div class="module-header">
				<h2 class="heading-5 text-color-content-primary">{{ category.name }}</h2>
			</div>
			<div class="module-section">
				<p class="text-color-content-primary">{{ category.description }}</p>
				<p class="cta-link--rust mt-100 zeta text-align-right">View articles</p>
			</div>
		</BaseLink>
	</div>
</template>

<script setup lang="ts">
import { HelpCenterCategory } from 'types/help-center';
interface Props {
	category: HelpCenterCategory;
}

defineProps<Props>();
</script>

<style lang="scss" scoped>
@use '../../styles/constants/colors' as *;
@use '../../styles/utilities/respond-to.scss' as *;

.category-tile {
	cursor: pointer;
	transition: 0.25s all ease;

	@include respond-to(mdo) {
		height: 300px;
	}

	&:hover {
		transform: translateY(-2px);

		&:active {
			transform: none;
		}

		.cta-link--rust {
			color: orange(70);
		}
	}
}
</style>
